import type { CSSObject } from '@emotion/react'
import { FontWeight, Spacing } from '@opallabs/gem'

export const selectLabelOverrides: CSSObject = {
  fontWeight: FontWeight.Medium,
  marginBottom: Spacing.XS,
}

export const labelOverrides: CSSObject = {
  marginTop: Spacing.L,
}
